<template>
  <el-dialog class="dialog" :title="dialogTitle" v-if="dialogVisible" :visible.sync="dialogVisible" width="50%" top="10vh">
    <!-- 工具栏 -->
    <div class="filter-container">
      <el-input class="filter-item" size="small" v-model="search" clearable placeholder="名称模糊查询" style="width: 220px"></el-input>
      <div style="display:inline-block;float:right">
        <el-button class="filter-item" size="small" icon="el-icon-delete" @click="selectionDelete">批量删除</el-button>
        <el-button class="filter-item" size="small" icon="el-icon-circle-plus-outline" type="primary" @click="editFun()">添加内容</el-button>

      </div>
    </div>

    <!-- table 列表-->
    <el-table class="grayTableTile" size="mini" v-loading="listLoading" ref="multipleTable" :row-key="getRowKeys" :data="tableList" border style="width: 100%" @sort-change="handleAgeSortChange"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column prop="name" label="标签内容" sortable='custom'></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="editFun(scope.row)">编辑</el-button>
          <el-button type="text" @click="deleteFun(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" style="margin-top:0;" />

    <!-- 编辑添加组件 -->
    <el-dialog append-to-body :visible='miniDialog' :title='miniDialogTitle' width="25%">
      <el-form :model="miniForm" :rules="miniRulesForm" ref="ruleForm" label-width="100px" v-if="miniDialog">
        <!-- 是否合作 -->
        <el-form-item class="form-item form-inline-item" label="标签内容" prop="content">
          <el-input v-model="miniForm.content" style="width:90%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="right-box">
          <el-button class="button-primary-plain" size="small" @click="miniDialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="handleSave">确 定</el-button>
        </div>
      </div>

    </el-dialog>

  </el-dialog>
</template>

<script>
import Pagination from '@/components/Pagination'
import { permissioninfo, roledoRemovePermission } from '@Sys~/api/sys'
import { arrSlice, sortKeys } from '@/filters'
export default {
  components: { Pagination },
  data() {
    return {
      dialogTitle: '',
      dialogVisible: false,

      search: '',
      listLoading: false,
      originalCaseTable: [],// 排序原始数据
      caseTable: [], // 存放后端一次性返回的所有数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      userInfo: {}, // 详情

      multipleSelection: [], // 选中

      //新增，编辑
      miniDialog: false,
      miniDialogTitle: '',
      //校验表单
      miniRulesForm: {
        content: [{ required: true, message: '请输入标签内容', trigger: 'blur' }],
      },
      miniForm: {
        content: ''
      }
    }
  },

  computed: {
    tableList() {
      let caseTable = this.caseTable
      const search = this.search.toLowerCase().replace(/\s+/g, "");
      if (search) {
        caseTable = this.caseTable.filter(data => {
          return String(data['name']).toLowerCase().indexOf(search) > -1 || String(data['title']).toLowerCase().indexOf(search) > -1
        })
      }

      this.total = caseTable.length
      // 将一维数组切割成二维数组
      this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
      this.tableData = this.handCaseTable[this.listQuery.pageNo - 1]
      return this.tableData
    }
  },

  methods: {
    init(row) {
      this.dialogTitle = "标签详情：" + row.name // 标题
      this.dialogVisible = true
      this.userInfo = row
      this.search = ''
      this.listLoading = false
      this.tableData = []
      this.total = 0
      this.listQuery = {
        pageNo: 1,
        pageSize: 10
      }

      this.multipleSelection = []

      this.getList(row)
    },

    // 获取列表
    getList(row) {
      this.listLoading = true
      permissioninfo(row.id).then(response => {
        this.listLoading = false;
        if (response.code == 1) {
          this.caseTable = response.data.roles;
          this.originalCaseTable = JSON.parse(JSON.stringify(this.caseTable))

          this.$refs.multipleTable.clearSelection();
        }
      });
    },

    // 排序
    handleAgeSortChange(e) {
      if (e.order) {
        const order = e.order == 'descending' ? true : false
        this.caseTable.sort(sortKeys(e.prop, order))
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
      }
    },

    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    // 设置回显的函数 当前行的数据，需要一个唯一的标识来标记是哪一个被选中了
    getRowKeys(row) {
      // console.log(row)
      return row.id
    },

    // 批量删除
    selectionDelete() {
      if (this.multipleSelection.length > 0) {
        const ids = []
        this.multipleSelection.forEach(m => {
          ids.push(m.id)
        });

        const data = {
          permissionIds: [this.userInfo.id],
          roleId: ids
        }
        this.handleDelete(data)
      } else {
        this.$message({
          message: "请先选择要删除的用户权限",
          type: "error"
        });
      }
    },

    // 单个删除
    deleteFun(row) {
      const data = {
        permissionIds: [this.userInfo.id],
        roleId: [row.id]
      }
      this.handleDelete(data, row)
    },

    // 操作删除
    handleDelete(data, row) {
      this.$confirm(row ? '确认删除标签内容：' + row.title + '" ？' : '确认删除所选标签内容吗？').then(_ => {
        // roledoRemovePermission(data).then(response => {
        //   if (response.code == 1) {
        //     this.$message({
        //       message: "删除成功",
        //       type: "success"
        //     });
        //     this.getList(this.userInfo)
        //   }
        // });
      }).catch(_ => { });
    },

    // 添加,编辑
    editFun(row) {
      this.miniDialog = true;
      this.miniDialogTitle = row ? '编辑标签内容' : '新增标签内容'
    },
  }
}
</script>